import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faHtml5,
	faCss3Alt,
	faJs,
	faReact,
	faNodeJs,
	faPython,
} from "@fortawesome/free-brands-svg-icons";
import { faServer } from "@fortawesome/free-solid-svg-icons";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";

import { useLanguage } from "../i18n/LanguageContext";

import "./styles/skills.css";

const SKILLS = [
	{ key: "html", name: "HTML", icon: faHtml5, color: "#e34f26" },
	{ key: "css", name: "CSS", icon: faCss3Alt, color: "#1572b6" },
	{ key: "js", name: "JavaScript", icon: faJs, color: "#f7df1e" },
	{ key: "react", name: "React JS", icon: faReact, color: "#61dafb" },
	{ key: "node", name: "Node.js", icon: faNodeJs, color: "#5fa04e" },
	{ key: "express", name: "Express.js", icon: faServer, color: "#e2e8f0" },
	{ key: "python", name: "Python", icon: faPython, color: "#ffd43b" },
	{ key: "cpp", name: "C++", text: "C++", color: "#659ad2" },
];

const Skills = () => {
	const { t, messages } = useLanguage();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const seo = messages.seo.skills;
	const page = messages.skillsPage;

	return (
		<React.Fragment>
			<Helmet>
				<title>{`${t("titles.skills")} | ${t("main.siteTitle")}`}</title>
				<meta name="description" content={seo.description} />
				<meta name="keywords" content={seo.keywords.join(", ")} />
			</Helmet>

			<div className="page-content">
				<NavBar active="skills" />
				<div className="content-wrapper">
					<div className="skills-container">
						<div className="title skills-title">{page.title}</div>

						<div className="subtitle skills-subtitle">
							{page.subtitle}
						</div>

						<div className="skills-grid">
							{SKILLS.map((s) => (
								<div
									className="skill-card"
									key={s.key}
									style={{ "--skill-color": s.color }}
								>
									<div className="skill-icon">
										{s.icon ? (
											<FontAwesomeIcon icon={s.icon} />
										) : (
											<span className="skill-icon-text">{s.text}</span>
										)}
									</div>
									<div className="skill-name">{s.name}</div>
									<div className="skill-text">
										{page.items[s.key]}
									</div>
								</div>
							))}
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Skills;
